// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLERS_CHARTS_BY_PROFILE_COUNT_HEADING = "Nejpopul\u00e1rn\u011bj\u0161\u00ed ko\u010d\u00e1rky";
export const STROLLERS_CHARTS_BY_USER_SCORE_DESCRIPTION = "Ko\u010d\u00e1rek mus\u00ed m\u00edt aspo\u0148 5 hodnocen\u00ed.";
export const STROLLERS_CHARTS_BY_USER_SCORE_HEADING = "Nejl\u00e9pe hodnocen\u00e9 ko\u010d\u00e1rky";
